export default __webpack_public_path__ + "static/media/about-img.3ea2b32c.jpg";